var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs',_vm._b({attrs:{"initialTab":_vm.activeTab},on:{"toggle":_vm.persistActiveTab}},'tabs',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }